import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Icon as ZinniaIcon, } from '@zapier/design-system';
export function Icon(props) {
    return _jsx(ZinniaIcon, Object.assign({}, props));
}
//# sourceMappingURL=Icon.js.map